module.exports = __webpack_public_path__ + "ef2b019c2c5523f1ecb93a7344d65475.svg";